// extracted by mini-css-extract-plugin
export default {"header":"UploadMusic_header__O5O3i","UploadMusic":"UploadMusic_UploadMusic__tU1gn"};